import React, { useEffect, useState } from 'react';
import { BreadcrumbGroup, Button, Checkbox, Container, FormField, Grid, Header, Input, Popover, SpaceBetween, StatusIndicator, Tabs } from '@cloudscape-design/components';
import { CustomAppLayout } from '../../layout';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { storeCounters, storeJWT } from '../../../commons/functions';
import Icon from '@mdi/react';
import { mdiContentSave, mdiAsteriskCircleOutline } from '@mdi/js';
import { useStoreAdmin } from '../../../context/useStoreAdmin';

const pageSize = 20;
interface VisitorOption {
  value: string;
  description: string;
}
export const ConfigPropertyPage = () => {
  const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { idControl, setIdControl } = useGlobalState();
  const { JWT } = useGlobalState();
  const { propiedad } = useGlobalState();  // Stores selected row data
  const { setLoading } = useGlobalState();
  const [invitationsMaxGuestCount, setInvitationsMaxGuestCount] = useState(0)
  const [invitationsMaxTime, setInvitationsMaxTime] = useState(0)

  const [visitorsReqAuth, setVisitorsReqAuth] = useState(0)
  const [visitorsExpires, setVisitorsExpires] = useState(0)

  const [visitorsInfoReq, setVisitorsInfoReq] = useState<string[]>([]);
  const [visitorsInfo, setVisitorsInfo] = useState<string[]>([]);

  const [mailingReqAuth, setMailingReqAuth] = useState(0)
  const [mailingExpires, setMailingExpires] = useState(0)
  const [mailingInfoReq, setMailingInfoReq] = useState<string[]>([]);
  const [mailingInfo, setMailingInfo] = useState<string[]>([]);
  const [deliveryInfo, setDeliveryInfo] = useState<string[]>([]);
  const [deliveryInfoReq, setDeliveryInfoReq] = useState<string[]>([]);

  const [deliveryReqAuth, setDeliveryReqAuth] = useState(0)
  const [deliveryExpires, setDeliveryExpires] = useState(0)


  const visitorOptions: VisitorOption[] = [
    { value: "RUT", description: "RUT" },
    { value: "NOMBRE", description: "Nombre" },
    { value: "TRANSPORT", description: "Medio de transporte" },
    { value: "PAX", description: "Total de ocupantes" },
    { value: "EMPRESA", description: "Nombre de empresa" },
    { value: "PPU", description: "Matrícula" },
    { value: "IMG", description: "Evidencia fotográfica" },
  ]
  const visitorOptionsReq: VisitorOption[] = [
    { value: "RUT", description: "RUT" },
    { value: "NOMBRE", description: "Nombre" },
    { value: "TRANSPORT", description: "Medio de transporte" },
    { value: "PAX", description: "Total de ocupantes" },
    { value: "EMPRESA", description: "Nombre de empresa" },
    { value: "PPU", description: "Matrícula" },
    { value: "IMG", description: "Evidencia fotográfica" },
  ]


  const [selectedVisitorOptions, setSelectedVisitorOptions] = useState<string[]>([]);
  const [selectedVisitorOptionsReq, setSelectedVisitorOptionsReq] = useState<string[]>([]);

  const handleChangeVisitorOptions = (value: string, checked: boolean) => {
    setVisitorsInfo(prev =>
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );

    // Also uncheck from required if unchecked
    if (!checked) {
      setVisitorsInfoReq(prev => prev.filter(v => v !== value));
    }
  };

  const handleChangeVisitorOptionsReq = (value: string, checked: boolean) => {
    setVisitorsInfoReq(prev =>
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );
  };

  const handleChangeMailingOptions = (value: string, checked: boolean) => {
    setMailingInfo(prev =>
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );
    // Also uncheck from required if unchecked
    if (!checked) {
      setMailingInfoReq(prev => prev.filter(v => v !== value));
    }
  };

  const handleChangeMailingOptionsReq = (value: string, checked: boolean) => {
    setMailingInfoReq(prev =>
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );
  }
  const handleChangeDeliveryOptions = (value: string, checked: boolean) => {
    setDeliveryInfo(prev =>
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );
    // Also uncheck from required if unchecked
    if (!checked) {
      setDeliveryInfoReq(prev => prev.filter(v => v !== value));
    }
  };

  const handleChangeDeliveryOptionsReq = (value: string, checked: boolean) => {
    setDeliveryInfoReq(prev =>
      checked ? [...prev, value] : prev.filter(v => v !== value)
    );
  };


  const handleSave = async () => {
    console.log(visitorsReqAuth)
    let body = {
      invitationsMaxGuestCount: invitationsMaxGuestCount,
      invitationsMaxTime: invitationsMaxTime,

      visitorsReqAuth: visitorsReqAuth,
      visitorsExpires: visitorsExpires,
      mailingReqAuth: mailingReqAuth,
      mailingExpires: mailingExpires,
      deliveryReqAuth: deliveryReqAuth,
      deliveryExpires: deliveryExpires,


      visitorsInfo: visitorsInfo.join(','),
      visitorsInfoReq: visitorsInfoReq.join(','),
      mailingInfo: mailingInfo.join(','),
      mailingInfoReq: mailingInfoReq.join(','),
      deliveryInfo: deliveryInfo.join(','),
      deliveryInfoReq: deliveryInfoReq.join(','),
    }

    try {

      setLoading(true);
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/properties/config',
          'JWT': JWT,

        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      storeAdmin(data);
      if (data.admin.counters) {
        const { setPendingAuth, setInvoicesExpired, setShowPropertiesSelector } = useGlobalState();
        storeCounters(data, setInvoicesExpired, setPendingAuth, setShowPropertiesSelector);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
      handleRefresh()
    }
  };
  const handleRefresh = async () => {
    try {

      setLoading(true);
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/properties/get',
          'JWT': JWT,

        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      storeAdmin(data);

      if (data.code === 0) {
        setInvitationsMaxGuestCount(data.admin.property.invitationsMaxGuestCount)
        setInvitationsMaxTime(data.admin.property.invitationsMaxTime)

        setVisitorsReqAuth(data.admin.property.visitorsReqAuth)
        setVisitorsExpires(data.admin.property.visitorsExpires)
        setVisitorsInfo(data.admin.property.visitorsInfo.split(",").map((s: string) => s.trim()));
        setVisitorsInfoReq(data.admin.property.visitorsInfoReq.split(",").map((s: string) => s.trim()));

        setMailingReqAuth(data.admin.property.mailingReqAuth)
        setMailingExpires(data.admin.property.mailingExpires)
        setMailingInfo(data.admin.property.mailingInfo.split(",").map((s: string) => s.trim()));
        setMailingInfoReq(data.admin.property.mailingInfoReq.split(",").map((s: string) => s.trim()));

        setDeliveryReqAuth(data.admin.property.deliveryReqAuth)
        setDeliveryExpires(data.admin.property.deliveryExpires)
        setDeliveryInfo(data.admin.property.deliveryInfo.split(",").map((s: string) => s.trim()));
        setDeliveryInfoReq(data.admin.property.deliveryInfoReq.split(",").map((s: string) => s.trim()));
      }
      console.log(data)
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);

    }
  };


  useEffect(() => {
    handleRefresh();
  }, []);

  return (

    <>


      <CustomAppLayout
        toolsHide
        contentType='form'
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              { text: 'Inicio', href: '#home' },
              { text: 'Configuración', href: '#config/default' },
              { text: 'Propiedad', href: '#create-transcription-job' },
            ]}
            expandAriaLabel="Show path"
            ariaLabel="Breadcrumbs"
          />
        }
        content={
          <>
            <Container
              header={<Header>Configuración de propiedad</Header>}
              footer={
                <Box textAlign='right'><Button variant='primary' onClick={handleSave}>Guardar cambios</Button></Box>
              }
            >

              <Tabs
                tabs={[
                  {
                    label: "General",
                    id: "general",
                    content: (
                      <>
                        <FormField
                          label='Máximo de invitados'
                          constraintText='Total de invitaciones que el usuario puede registrar para un mismo bloque horario'
                        >
                          <Input
                            type='number'
                            value={invitationsMaxGuestCount.toString()}
                            onChange={({ detail }) => setInvitationsMaxGuestCount(Number(detail.value))}
                          >
                          </Input>
                        </FormField>
                        <FormField
                          label='Extensión Máxima'
                          constraintText='Tiempo total máximo en horas para una invitación'
                        >
                          <Input
                            type='number'
                            value={invitationsMaxTime.toString()}
                            onChange={({ detail }) => setInvitationsMaxTime(Number(detail.value))}
                          >
                          </Input>
                        </FormField>
                        </>
                    )
                  },
                  {
                    label: "Visitas",
                    id: "visits",
                    content: (
                      <>
                        <SpaceBetween direction='vertical' size='xs'>
                          <SpaceBetween direction='horizontal' size='xs'>
                            <FormField
                              constraintText='El usuario es notificado de el arribo de la visita y puede realizar la autorización desde tu dispositivo. En caso de desactivar, el usuario solo será notificado del arribo de la visita'
                            >
                              <Checkbox
                                onChange={({ detail }) => setVisitorsReqAuth(detail.checked ? 1 : 0)}
                                checked={visitorsReqAuth === 1}

                              >Autorización de visitas
                              </Checkbox>
                            </FormField>
                            <FormField
                              label='Tiempo de expiración de la visita'
                              constraintText='Periodo en horas hasta que la notificación deja de estar disponible para el usuario'
                            >
                              <Input
                                type='number'
                                value={visitorsExpires.toString()}
                                onChange={({ detail }) => setVisitorsExpires(Number(detail.value))}
                              >
                              </Input>
                            </FormField>
                          </SpaceBetween>
                          <Grid gridDefinition={[{ colspan: { default: 3 } }, { colspan: { default: 3 } }]}>
                            <FormField label="Información solicitada">
                              {visitorOptions.map(option => (
                                <Checkbox
                                  key={option.value}
                                  checked={visitorsInfo.includes(option.value)}
                                  onChange={({ detail }) => handleChangeVisitorOptions(option.value, detail.checked)}
                                >
                                  {option.description}
                                </Checkbox>
                              ))}
                            </FormField>
                            <FormField label={
                              <Popover
                                dismissButton={false}
                                position="top"
                                size="small"
                                triggerType="custom"
                                content={
                                  <StatusIndicator type="info">Obligatoriedad</StatusIndicator>
                                }
                              >
                                <Icon path={mdiAsteriskCircleOutline} size={1} />
                              </Popover>
                            }>

                              {visitorOptions.map(option => {
                                const isEnabled = visitorsInfo.includes(option.value);
                                return (
                                  <Checkbox
                                    key={option.value}
                                    checked={visitorsInfoReq.includes(option.value)}
                                    disabled={!isEnabled}
                                    onChange={({ detail }) =>
                                      handleChangeVisitorOptionsReq(option.value, detail.checked)
                                    }

                                  >{" "}
                                  </Checkbox>
                                );
                              })}
                            </FormField>
                          </Grid>
                        </SpaceBetween>
                      </>
                    )
                  },
                  {
                    label: "Encomiendas",
                    id: "mail",
                    content: (
                      <>
                        <SpaceBetween direction='vertical' size='xs'>
                          <SpaceBetween direction='horizontal' size='xs'>
                            <FormField
                              constraintText='El usuario es notificado de el arribo de la encomienda y puede realizar la autorización desde tu dispositivo. En caso de desactivar, el usuario solo será notificado del arribo de la encomienda'
                            >
                              <Checkbox
                                onChange={({ detail }) => setMailingReqAuth(detail.checked ? 1 : 0)}
                                checked={mailingReqAuth === 1}

                              >Autorización de encomiendas
                              </Checkbox>
                            </FormField>
                            <FormField
                              label='Tiempo de expiración de la notificación'
                              constraintText='Periodo en horas hasta que la notificación deja de estar disponible para el usuario'
                            >
                              <Input
                                type='number'
                                value={mailingExpires.toString()}
                                onChange={({ detail }) => setMailingExpires(Number(detail.value))}
                              >
                              </Input>
                            </FormField>
                          </SpaceBetween>
                          <Grid gridDefinition={[{ colspan: { default: 3 } }, { colspan: { default: 3 } }]}>
                            <FormField label="Información solicitada">
                              {visitorOptions.map(option => (
                                <Checkbox
                                  key={option.value}
                                  checked={mailingInfo.includes(option.value)}
                                  onChange={({ detail }) => handleChangeMailingOptions(option.value, detail.checked)}
                                >{option.description}</Checkbox>
                              ))}
                            </FormField>
                            <FormField label={

                              <Popover
                                dismissButton={false}
                                position="top"
                                size="small"
                                triggerType="custom"
                                content={
                                  <StatusIndicator type="info">Obligatoriedad</StatusIndicator>
                                }
                              >
                                <Icon path={mdiAsteriskCircleOutline} size={1} />
                              </Popover>
                            }>
                              {visitorOptions.map(option => {
                                const isEnabled = mailingInfo.includes(option.value);
                                return (
                                  <Checkbox
                                    key={option.value}
                                    checked={mailingInfo.includes(option.value)}
                                    disabled={!isEnabled}
                                    onChange={({ detail }) =>
                                      handleChangeMailingOptionsReq(option.value, detail.checked)
                                    }
                                  >
                                    {" "}
                                  </Checkbox>
                                );
                              })}
                            </FormField>
                          </Grid>
                        </SpaceBetween>
                      </>
                    )
                  },
                  {
                    label: "Delivery",
                    id: "delivery",
                    content: (
                      <>
                        <SpaceBetween direction='vertical' size='xs'>
                          <SpaceBetween direction='horizontal' size='xs'>
                            <FormField
                              constraintText='El usuario es notificado de el arribo del delivery y puede realizar la autorización desde tu dispositivo. En caso de desactivar, el usuario solo será notificado del arribo del delivery'
                            >
                              <Checkbox
                                onChange={({ detail }) => setDeliveryReqAuth(detail.checked ? 1 : 0)}
                                checked={deliveryReqAuth === 1}

                              >Autorización de deliveries
                              </Checkbox>
                            </FormField>
                            <FormField
                              label='Tiempo de expiración de la notificación'
                              constraintText="Periodo en horas hasta que la notificación deja de estar disponible para el usuario"
                            >
                              <Input
                                type='number'
                                value={deliveryExpires.toString()}
                                onChange={({ detail }) => setDeliveryExpires(Number(detail.value))}
                              >
                              </Input>
                            </FormField>
                          </SpaceBetween>
                          <Grid gridDefinition={[{ colspan: { default: 3 } }, { colspan: { default: 3 } }]}>
                            <FormField label="Información solicitada">
                              {visitorOptions.map(option => (
                                <Checkbox
                                  key={option.value}
                                  checked={deliveryInfo.includes(option.value)}
                                  onChange={({ detail }) => handleChangeDeliveryOptions(option.value, detail.checked)}
                                >
                                  {option.description}
                                </Checkbox>
                              ))}
                            </FormField>
                            <FormField label={

                              <Popover
                                dismissButton={false}
                                position="top"
                                size="small"
                                triggerType="custom"
                                content={
                                  <StatusIndicator type="info">Obligatoriedad</StatusIndicator>
                                }
                              >
                                <Icon path={mdiAsteriskCircleOutline} size={1} />
                              </Popover>
                            }>
                              {visitorOptions.map(option => {
                                const isEnabled = deliveryInfo.includes(option.value);
                                return (
                                  <Checkbox
                                    key={option.value}
                                    checked={deliveryInfoReq.includes(option.value)}
                                    disabled={!isEnabled}
                                    onChange={({ detail }) =>
                                      handleChangeDeliveryOptionsReq(option.value, detail.checked)
                                    }
                                  >{" "}
                                  </Checkbox>
                                );
                              })}
                            </FormField>
                          </Grid>
                        </SpaceBetween>
                      </>
                    )
                  }
                ]}
              />
            </Container>
          </>
        }
      />
    </>
  );

};
